/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './account_request_response';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "account": {
                "nested": {
                  "DashboardWebAccountService": {
                    "methods": {
                      "CreateAccount": {
                        "requestType": ".squareup.bbfrontend.dashboard.account.CreateAccountRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.account.CreateAccountResponse"
                      },
                      "DeactivateAccount": {
                        "requestType": ".squareup.bbfrontend.dashboard.account.DeactivateAccountRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.account.DeactivateAccountResponse"
                      },
                      "UpdateAccount": {
                        "requestType": ".squareup.bbfrontend.dashboard.account.UpdateAccountRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.account.UpdateAccountResponse"
                      },
                      "ListAccounts": {
                        "requestType": ".squareup.bbfrontend.dashboard.account.ListAccountsRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.account.ListAccountsResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.DashboardWebAccountService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DashboardWebAccountService @ squareup/bbfrontend/dashboardweb/account/account_service.proto at 12:1
 */
export const DashboardWebAccountService = $root.lookupService('squareup.bbfrontend.dashboard.account.DashboardWebAccountService');